/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Recipes_Search_PlaceholderInputs */

const en_recipes_search_placeholder = /** @type {(inputs: Recipes_Search_PlaceholderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Search ${i?.count} recipes, ingredients, tags`)
};

const de_recipes_search_placeholder = /** @type {(inputs: Recipes_Search_PlaceholderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Rezepte, Zutaten, Tags durchsuchen`)
};

/**
* | output |
* | --- |
* | "Search {count} recipes, ingredients, tags" |
*
* @param {Recipes_Search_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipes_search_placeholder = /** @type {((inputs: Recipes_Search_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipes_Search_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipes_search_placeholder(inputs)
	return en_recipes_search_placeholder(inputs)
});